import React from 'react';

function Programs(props) {
    return (
        <>
        <h2 className="programs-heading text-center mt-3">
            What We offer
        </h2>
        <p className="programs-intro text-center text-secondary">
            We offer the best curated training services to a variety of clients with zero experience to intermediate experience who want to improve their technical skills. The following are lists of training packages:
        </p>
            <div className="row">
                <div className="col col-12 ">
                    <div className="card border-0 bg-transparent">
                        <a href="/#" className="card-link">
                        <div className="card-body bg-white my-2 border-start border-primary border-3 p-4">
                            <div className="card-icon d-flex justify-content-center">
                                <img src="/assets/solar-energy.svg" alt="solar installation" className="w-100 pt-2"/>
                            </div>
                            <h4 className="card-title pt-1">Solar Installation and Maintenance</h4>
                            <p className="card-text text-secondary">This package is a 3-6months duration paid training on Solar power installation, load analysis, bill estimation (B.E.M.E.) and inverter-sizing, with a free month subscription</p>
                        </div>
                        </a>
                    </div>
                </div>
                <div className="col col-12 ">
                    <div className="card border-0 bg-transparent">
                        <a href="/#" className="card-link">
                            <div className="card-body bg-white my-2 border-start border-primary border-3 p-4">
                                <div className="card-icon d-flex justify-content-center">
                                    <img src="/assets/cctv.svg" alt="cctv installation" className="w-100 pt-2"/>
                                </div>
                                <h4 className="card-title pt-1">CCTV Surveillance Installation and Maintenance</h4>
                                <p className="card-text text-secondary">This package is also a 3-6months training on CCTV installation processes, positioning and footage management, with a free month subscription</p>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="col col-12 ">
                    <div className="card border-0 bg-transparent">
                        <a href="/#" className="card-link">
                            <div className="card-body bg-white my-2 border-start border-primary border-3 p-4">
                                <div className="card-icon d-flex justify-content-center">
                                    <img src="/assets/code-vector.svg" alt="Software development" className="w-100"/>
                                </div>
                                <h4 className="card-title pt-2">Software Development and Management</h4>
                                <p className="card-text text-secondary">This package is a 3-6months offers an in-depth training on modern software development processes/strategies with respect to the ever changing software implementation worldwide, with a free month subscription</p>
                            </div>
                        </a>
                    </div>
                </div>
               
                <a href="/programs" className="see-more btn col-3 btn-outline-secondary">
                    <span className="px-2" >
                    See More 
                    </span>
                    <i className="fas fa-arrow-right ml-4"></i>
                </a>
            </div>
        </>
    );
}

export default Programs;